export default __webpack_public_path__ + "static/media/ha1.777ed714.jpg";